import {apiSlice} from './apiSlice';

/**
 * Endpoints tool "Kỹ thuật SEO" (bên trong Project) — các báo cáo kỹ thuật tách từ lần
 * crawl mới nhất (liên kết nội bộ/hỏng, redirect, robots). Dùng chung tag 'Crawl' vì dữ
 * liệu nguồn là của Site Crawler.
 *
 * - getTechnicalReport: toàn bộ báo cáo (1 request; các tab đổi view phía client).
 * - getSitemapReport: Sitemap Manager (#11) — tải sitemap live + đối chiếu URL đã crawl.
 *   Tách endpoint riêng vì tải sitemap là HTTP live (chậm) → FE gọi lazy khi mở tab.
 * - traceRedirect: công cụ nhập URL lẻ → trace chuỗi chuyển hướng HTTP thật.
 */
export const technicalApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getTechnicalReport: builder.query({
			query: (projectId) => ({url: `technical/projects/${projectId}`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, projectId) => [{type: 'Crawl', id: `technical-${projectId}`}],
		}),
		getSitemapReport: builder.query({
			query: (projectId) => ({url: `technical/projects/${projectId}/sitemap`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, projectId) => [{type: 'Crawl', id: `sitemap-${projectId}`}],
		}),
		traceRedirect: builder.mutation({
			query: ({projectId, url}) => ({url: `technical/projects/${projectId}/trace-redirect`, method: 'post', data: {url}}),
			transformResponse: (body) => body?.data || null,
		}),
	}),
});

export const {
	useGetTechnicalReportQuery,
	useGetSitemapReportQuery,
	useTraceRedirectMutation,
} = technicalApiSlice;
